import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { ROUTES } from '@/shared/config/routes';
import { FullscreenLoader } from '@/shared/ui/feedback/FullscreenLoader';
import { useAuth } from '../useAuth';

/** Gate a route behind authentication; redirects to /auth, preserving the target. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullscreenLoader />;
  if (status === 'unauthenticated') {
    return <Navigate to={ROUTES.auth} replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
